import { computed, Directive, effect, input, model } from '@angular/core';
import { FormControl } from '@angular/forms';

/**
 * A simple base component for effective controls that can be used in the application detail page.
 * It manages the logic of determining the effective FormControl to use (either the provided one or a fallback)
 * and synchronizing its value and disabled state based on the inputs.
 */
@Directive()
export abstract class SimpleBaseEffectiveControlComponent<T> {
    public readonly value = input.required<T>();
    public readonly readonly = input<boolean>(false);
    public readonly isLoading = model<boolean>(false);
    public readonly control = input<FormControl<T>>();
    protected readonly effectiveControl = computed(() => {
        const ctrl = this.control();
        if (ctrl) return ctrl;
        const fallback = new FormControl<T>(this.value(), { nonNullable: true });
        fallback.disable();
        return fallback;
    });

    constructor() {
        effect(() => this.patchValue(this.effectiveControl(), this.value()));
    }

    protected patchValue(effectiveControl: FormControl<T>, value: T): void {
        if (effectiveControl) {
            effectiveControl.patchValue(value);
        }
    }
}
